import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { AuthService } from "../../auth/auth.service";
import { takeUntil } from "rxjs/operators";

/**
 * This component acts as the main toolbar for the Online Claims application.
 */
@Component({
	selector: 'claims-app-toolbar',
	templateUrl: './claims-app-toolbar.component.html'
})
export class ClaimsAppToolbarComponent implements OnInit, OnDestroy {
	/**
	 * A subject that can be used to automatically end subscriptions when the component is destroyed.
	 * @private
	 */
	private readonly _destroying$ = new Subject<void>();
	
	// Indicates if the user is logged in (authenticated).
	isLoggedIn = false;
	// The authenticated user's name.
	userName: string = "";

	/**
	 * @constructor
	 * @param authService The {@link AuthService} to use for login and logout requests.
	 */
	constructor(private authService: AuthService) {	}

	ngOnInit() {
		this.authService.loginStatusChanged
			.pipe(takeUntil(this._destroying$))
			.subscribe(() => this.setLoginDisplay());
		// Perform an initial update.
		this.setLoginDisplay();
	}

	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}

	/**
	 * Starts the login flow.
	 * @see AuthService.login
	 */
	login() {
		this.authService.login();
	}

	/**
	 * Starts the logout flow.
	 * @see AuthService.logout
	 */
	logout() {
		this.authService.logout();
	}

	/**
	 * Updates properties used by the view based on the authenticated user.
	 * @see AuthService.isLoggedIn
	 * @see AuthService.getAccount
	 */
	setLoginDisplay() {
		this.isLoggedIn = this.authService.isLoggedIn();
		this.userName = this.authService.getActiveAccount()?.username;
	}
}